/* RESPONSIBLE TEAM: team-automation-foundations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-controllers */
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import RouteRegexes from 'embercom/lib/route-regexes';
import { assetUrl } from '@intercom/pulse/helpers/asset-url';
import { hasFeature } from 'embercom/helpers/has-feature';

export default class AutomationController extends Controller {
  @service router;
  @service store;
  @service navbarCollapsingService;
  @service appService;
  @service intl;
  @service contentImportService;
  @service commonPrimaryNavBarService;

  get app() {
    return this.appService.app;
  }

  get isOnReportingRoute() {
    return RouteRegexes.operatorReporting.test(this.router.currentName);
  }
  get isOnSolveOnboardingRoute() {
    return RouteRegexes.solveOnboarding.test(this.router.currentRouteName);
  }
  get isOnCustomBotOverviewRoute() {
    return RouteRegexes.customBotOverview.test(this.router.currentRouteName);
  }
  get isOnFinAIAgentRoute() {
    return RouteRegexes.automation.finAIAgent.test(this.router.currentRouteName);
  }
  get isOnFinAIAgentAnalyzeRoute() {
    return RouteRegexes.automation.analyze.test(this.router.currentRouteName);
  }
  get isOnSuggestionsRoute() {
    return RouteRegexes.automation.contentSuggestions.test(this.router.currentRouteName);
  }
  get isOnTestingRoute() {
    return RouteRegexes.automation.testing.test(this.router.currentRouteName);
  }
  get isOnAskRoute() {
    return RouteRegexes.automation.ask.test(this.router.currentRouteName);
  }
  get isOnWorkflowsRoute() {
    return RouteRegexes.automation.workflows.test(this.router.currentRouteName);
  }
  get isContentSuggestionsRoute() {
    return RouteRegexes.automation.contentSuggestions.test(this.router.currentRouteName);
  }
  get numberOfPendingItemsToReview() {
    return this.contentImportService.aiContentReviewSummary.pending;
  }

  get willDisplayPaywallInWorkflows() {
    return this.isOnWorkflowsRoute && !hasFeature('workflows_core_billing_feature');
  }

  get shouldDisplayFinSectionBanner() {
    return !this.willDisplayPaywallInWorkflows && !this.isContentSuggestionsRoute;
  }

  get isOnServiceAgentRoute() {
    let routeName = this.router.currentRouteName || '';
    return /^apps\.app\.automation\.fin-ai-agent\.(deploy\.[^.]+|content|guidance|attributes|escalation|procedures|analyze\.performance)(\..*)?$/.test(
      routeName,
    );
  }

  currentViewedCustomBotTarget = undefined;
  showSearch = true;

  initializeConfigurationModel() {
    let messengerResponseTimeKey =
      this.get('model.availability.messengerResponseTimeKey') || 'a_few_minutes';
    this.set(
      'previewConfiguration',
      this.store.createFragment('messenger-preview/configuration', {
        locale: 'en',
        backgroundPatternNumber: 1,
        logoURL: assetUrl('/assets/images/error/intercom-logo.png'),
        appPrimaryColor: this.get('model.lookAndFeel.primaryColor'),
        appPrimaryColorDark: this.get('model.lookAndFeel.primaryColorDark'),
        appSecondaryColor: this.get('model.lookAndFeel.secondaryColor'),
        appSecondaryColorDark: this.get('model.lookAndFeel.secondaryColorDark'),
        greetingText: this.intl.t('controllers.apps.app.operator.hi-there'),
        aboutUsText: this.intl.t('controllers.apps.app.operator.happy-to-help'),
        messengerResponseTimeKey,
        showWeRunOnIntercom: true,
        inboundConversationsEnabledForUsers: false,
        inboundConversationsEnabledForVisitors: false,
        launcherVisibleForUsers: true,
        launcherVisibleForVisitors: true,
      }),
    );
  }

  @action
  toggleSearch() {
    this.toggleProperty('showSearch');
    if (!this.showSearch) {
      this._resetSearch();
    }
  }

  _resetSearch() {
    this.router.transitionTo('apps.app.automation.workflows-overview', {
      queryParams: {
        title: null,
      },
    });
  }
}
